<template>
	<section class="page-intro row nav-offset justify-content-center w-100">
		
		<div v-b-modal.video-ceo class="col-md-3 position-relative text-center">
			<div class="full-height">
				<div class="img conversation-img"></div>
				<div class="text-container">
					<h3>A Conversation with Our Chairman & CEO</h3>
					<p >Watch Here</p>
				</div>
			</div>
		</div>

		<div class="col-md-3 position-relative tab tile-2 text-center">
            <div class="full-height" v-bind:class="{hover: ov['care']}" @click="toggleOverlay($event, 'care')">
				<div class="img care-img"></div>
    			<div class="text-container">
    				<h3>Sustaining care through adversity</h3>
    			</div>
    			<div class="overlay">
    				<div class="text-container">
    					<div class="heading">
    						Find out how we responded to the challenges of COVID-19:
    					</div>
    					<p><font-awesome-icon :icon="['fa', 'caret-right']" class="icon"/>
    						<router-link to='/covid' class='link'>Support for our sector
    						</router-link>
    					</p> 
    					<p><font-awesome-icon :icon="['fa', 'caret-right']" class="icon"/>
    						<router-link to='/support-public' class='link'>Support for seniors 	&amp; the public
    						</router-link>
    					</p>	
    				</div>
    			</div>
            </div>
		</div>


		<div class="col-md-3 position-relative tab tile-2 text-center">
            <div class="full-height justify-content-center position-relative" v-bind:class="{hover: ov['community']}" @click="toggleOverlay($event, 'community')">
				<div class="img community-img"></div>
                <div class="text-container">
                	<h3>Building a stronger care community</h3>
                </div>
                <div class="overlay">
                    <div class="text-container">
                        <div class='heading'>
                        	Read about our ongoing efforts to connect people to Community Care:
                        </div>
                        <p><font-awesome-icon :icon="['fa', 'caret-right']" class="icon"/>
    						<router-link to='/support-seniors' class='link'>Support for seniors, clients & caregivers
    						</router-link>
    					</p>
    					<p><font-awesome-icon :icon="['fa', 'caret-right']" class="icon"/>
    						<router-link to='/support-partners' class='link'>Support for partners
    						</router-link>
    					</p>
    					<p><font-awesome-icon :icon="['fa', 'caret-right']" class="icon"/>
    						<router-link to='/looking-ahead' class='link'>Looking ahead
    						</router-link>
    					</p>
                        
                    </div>
                </div>
			</div>
		</div>
		

		<div class="col-md-3 tab text-center">
			<div class="full-height justify-content-center position-relative" v-bind:class="{hover: ov['family']}" @click="toggleOverlay($event, 'family')">
				<div class="img family-img"></div>
				 <div class="text-container">
					<h3>Together as #OneAICFamily</h3>
				 </div>
				 <div class="overlay">
					<div class="text-container">
						<div class='heading'>At AIC, we pride ourselves on being a close knit family.</div>
						<p>
							<font-awesome-icon :icon="['fa', 'caret-right']" class="icon"/>
							<router-link to='/one-aic-family' class='link'>Find out more</router-link>
						</p>
						
					</div>
				 </div>
			</div>
		</div>



        <b-modal size="lg" hide-footer centered hide-header variant='light' id="video-ceo" ref='video-ceo' title="">
            <font-awesome-icon @click='hideModal' :icon="['fas', 'times']" class='modal-close'/>
             <iframe width="100%" height="500" src="https://www.youtube.com/embed/K3Upf20N3f0" title="Video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
		</b-modal>
	


	</section>
</template>

<script>
export default {
	name: 'PageIntro',
    data(){
        return {
            ov: {
                care : false,
                family: false,
                community: false
            },
        };
    },
    methods: {


    	hideModal() {
    		this.$refs['video-ceo'].hide()
    	},

        toggleOverlay: function(e, type){
            let ov = this.ov;
            
            if(this.mobileAndTabletCheck()){
                for (let t in ov){
                    if(t==type){
                        ov[type]=!ov[type];
                    }else{
                        ov[t]=false;                        
                    }
                }

            }else{
                for (let t in ov){
                    ov[t]=false;
                }                
            }
        },

        mobileAndTabletCheck (){

            let check = false;
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);

            return check;    
        },

    },

}
</script>

<style scoped>
	h3 {
		font-family: 'Montserrat Semibold';
		font-weight: 600;
    	font-size: 21px;
	}

	.icon {
		margin: 0 5px;
	}

	.overlay .heading {
		font-family: 'Frutiger Neue LT Bold';
		font-size: 18px;
		margin-bottom: 15px;
	}
	.overlay .link {
		font-family: 'Frutiger Neue LT Book';
	}

	.full-height img {
		height: 100% !important;
	}

	.img {
		background-size: cover !important;
		height: 100% !important;
	}

	.conversation-img {
		background: url('~@/assets/home/new-layout/Desktop-image1-2x.jpg');
	}

	.care-img {
		background: url('~@/assets/home/new-layout/Desktop-image2-2x.jpg');
	}
	
	.community-img {
		background: url('~@/assets/home/new-layout/Desktop-image3-2x.jpg');
	}

	.family-img {
		background: url('~@/assets/home/new-layout/Desktop-image4-2x.jpg');
	}


	@media(max-width: 768px){
		.overlay .heading {
			font-family: 'Montserrat SemiBold' !important;
		}
		.overlay .text-container {
			font-size: 18px;
		}

		.overlay .text-container p {
			margin: 8px 0;
		}
	}

	@media(max-width: 960px) {
		h3 {
			font-size: 18px;
		}

		.conversation-img {
			background: url('~@/assets/home/new-layout/Tablet-Portrait-only-image1-2x.jpg');
		}

		.care-img {
			background: url('~@/assets/home/new-layout/Tablet-Portrait-only-image2-2x.jpg');
		}
		
		.community-img {
			background: url('~@/assets/home/new-layout/Tablet-Portrait-only-image3-2x.jpg');
		}

		.family-img {
			background: url('~@/assets/home/new-layout/Tablet-Portrait-only-image4-2x.jpg');
		}
	} 

</style>
<style>
	/* tab */
	.full-height {
		height: 100%;
	}

	.text-over-img{
		text-shadow: 2px 2px 2px rgba(0, 0, 0, 1);
	}

	.img-container{
		width: 50%;
		height: 35%;
		margin: auto;
		margin-top: 10px;
	}

	.modal-body {
		padding: 0;
		border-radius: 0;
		margin-bottom: -6px;
	}

	.overlay .text-container{
		text-align: left;
		width: 70%;
	}

	.overlay{
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		max-width: 100%;
		display: none;
		transition: 0.5s ease;
		margin: auto;
		background-color: #74a3cb;
	}


    @media(hover: hover){
        .tab > *:hover .overlay{
            display: block;
        }
    }

    @media(hover: none){
        .hover .overlay{
            display: block;
        }
    }

    /* Mobile */
	@media(max-width: 760px){
		.text, h3, h4, h5 {
			font-family: 'Montserrat';
		}

		h3 {
			font-size: 26px !important;
		}

		.overlay .text-container a{
			font-size: 18px;
		}		

		.full-height {
			height: 50vh;
		}

		.conversation-img {
			background: url('~@/assets/home/new-layout/Mobile-image1-2x.jpg') !important;
		}

		.care-img {
			background: url('~@/assets/home/new-layout/Mobile-image2-2x.jpg') !important;
		}
		
		.community-img {
			background: url('~@/assets/home/new-layout/Mobile-image3-2x.jpg') !important;
		}

		.family-img {
			background: url('~@/assets/home/new-layout/Mobile-image4-2x.jpg') !important;
		}
	}

</style>
